import { BackButton } from 'components/AIRevision/Stepper/BackButton'
import { ForwardButton } from 'components/AIRevision/Stepper/ForwardButton'
import Styles from './Stepper.module.scss'
import { useStepper } from 'components/AIRevision/Stepper/StepperProvder'

export const Stepper = () => {
  const { step, steps } = useStepper()
  return (
    <div className={Styles.stepper}>
      <BackButton />
      <small className={Styles.steps}>
        {step} of {steps}
      </small>
      <ForwardButton />
    </div>
  )
}
